export const environment = {
  production: true,
  url_host: 'https://apiv2.pos-insights.com',

  // url_host:"https://apiv2.glimpseanalytics.com",
  // url_host:"http://143.34.198.7:8967",
  // url_host:"https://dev.pos-insights.com",
  // url_host:"https://costa-api.pos-insights.com",

  client_env: 'glimpse-main',
  is_oauth: false,
  project_sans_image: [
    'dashboard-pos',
    'shell',
    'c2c-pos',
    'pos-main',
    'covid',
    'dashboard',
    'pos-insights-demo',
    'mands',
    'glimpse-main',
    'northern-railway',
  ],

  'glimpse-main': {
    favicon: 'assets/favicons.ico',
    sidebar_image: '/assets/img/logo/logo_glimpse.png',
    title: 'Glimpse Analytics',
    home_route: '/footfalls',
    url_host: 'https://apiv2.pos-insights.com',
  },

  'northern-railway': {
    favicon: 'assets/favicons.ico',
    sidebar_image: '/assets/img/logo/logo_glimpse.png',
    title: 'Glimpse Analytics',
    home_route: '/vegetation',
    url_host: 'https://apiv2.pos-insights.com',
  },

  'costa-live': {
    favicon: 'assets/favicons.ico',
    sidebar_image: '/assets/img/logo/logo_glimpse.png',
    title: 'Glimpse Analytics',
    home_route: '/costa-queue-analysis',
    url_host: 'https://costa-api.pos-insights.com',
  },

  // prjoect configurations
  nihilent: {
    favicon: 'assets/img/logo/logo_argus.png',
    sidebar_image: 'assets/img/logo/logo_argus.png',
    title: 'Argus',
    home_route: '/footfalls',
    url_host: 'https://apiv2.glimpseanalytics.com',
  },
  'spatial-clue': {
    favicon: 'assets/img/logo/sc.ico',
    sidebar_image: 'assets/img/logo/sc.png',
    title: 'Spatial Clue',
    home_route: '/footfalls',
    url_host: 'https://apiv2.glimpseanalytics.com',
  },
  dashboard: {
    favicon: 'assets/favicons.ico',
    sidebar_image: '/assets/img/logo/logo_glimpse.png',
    title: 'Glimpse Analytics',
    url_host: 'https://apiv2.glimpseanalytics.com',
    home_route: '/footfalls',
  },

  covid: {
    favicon: 'assets/favicons.ico',
    sidebar_image: '/assets/img/logo/logo_glimpse.png',
    title: 'Glimpse Analytics',
    home_route: '/footfalls',
    url_host: 'https://apiv2.glimpseanalytics.com',
  },
  pandg: {
    favicon: 'assets/favicons.ico',
    sidebar_image: '/assets/img/logo/logo_glimpse.png',
    title: 'Glimpse Analytics',
    home_route: '/sd',
    url_host: 'https://apiv2.glimpseanalytics.com',
  },
  GroundLevelInsights: {
    favicon: 'assets/favicons.ico',
    sidebar_image: '/assets/img/logo/logo_gl.png',
    title: 'Groundlevel Insights',
    home_route: '/footfalls',
    url_host: 'https://apiv2.glimpseanalytics.com',
  },
  all: {
    favicon: 'assets/favicons.ico',
    sidebar_image: '/assets/img/logo/logo_glimpse.png',
    title: 'Glimpse Analytics',
    home_route: '/footfalls',
    url_host: 'https://apiv2.glimpseanalytics.com',
  },

  // pos api host. image should never be shown.
  'c2c-pos': {
    favicon: 'assets/favicon.ico',
    sidebar_image: '/assets/img/logo/logo_side_section.png',
    title: 'PoS Insights',
    home_route: '/footfalls',
    url_host: 'https://api.pos-insights.com',
  },

  'dashboard-pos': {
    favicon: 'assets/favicon.ico',
    sidebar_image: '/assets/img/logo/logo_side_section.png',
    title: 'PoS Insights',
    home_route: '/footfalls',
    url_host: 'https://api.pos-insights.com',
  },
  shell: {
    favicon: 'assets/favicon.ico',
    sidebar_image: '/assets/img/logo/logo_side_section.png',
    title: 'PoS Insights',
    home_route: '/footfalls',
    url_host: 'https://api.pos-insights.com',
  },
  mands: {
    favicon: 'assets/favicon.ico',
    sidebar_image: '/assets/img/logo/logo_side_section.png',
    title: 'PoS Insights',
    home_route: '/footfalls',
    url_host: 'https://api.pos-insights.com',
  },
  'pos-main': {
    favicon: 'assets/favicon.ico',
    sidebar_image: '/assets/img/logo/logo_side_section.png',
    title: 'PoS Insights',
    home_route: '/footfalls',
    url_host: 'https://api.pos-insights.com',
  },
  'pos-insights-demo': {
    favicon: 'assets/favicon.ico',
    sidebar_image: '/assets/img/logo/logo_side_section.png',
    title: 'PoS Insights',
    home_route: '/footfalls',
    url_host: 'https://api.pos-insights.com',
  },
  alt: {
    favicon: 'assets/favicon.ico',
    sidebar_image: '/assets/img/logo/alt.png',
    title: 'Altavia',
    home_route: '/footfalls',
    url_host: 'https://api.pos-insights.com',
  },
};
